import { ThemeConfigObject } from './types'

const reactAppCustomer = process.env.REACT_APP_CUSTOMER || ''

const variables: ThemeConfigObject = {
  customer: reactAppCustomer,
  loginImage: '/assets/loginImage.jpeg',
  loginImageBackgroundSize: 'cover',
  loginImageMobile: '/assets/logo.png',
  logoutImage: '/assets/loginImage.jpeg',
  logoutImageBackgroundSize: 'cover',
  colors: {
    accordionBorderless: {
      backgroundColor: 'transparent'
    },
    accordionSummary: {
      root: '#507FA5',
      expandIcon: '#507FA5'
    },
    activeSubMenuText: '#999',
    bottomBarMain: '#E8E8E8',
    buttonBasic: '#4D7CA4',
    infoBox: {
      border: '#BEBEBE',
      fontStyle: 'normal',
      text: '#787878'
    },
    inputField: {
      border: '#666'
    },
    inputLabel: {
      color: '#666'
    },
    mobileColumnBox: {
      borderBottom: '#999',
      borderTopFirst: '#507FA5',
      borderBottomLast: '#507FA5'
    },
    navigation: {
      navLink: {
        color: '#000'
      },
      navLinkActive: {
        borderBottom: '#013862'
      }
    },
    notaBene: '#C20219',
    primaryMain: '#FFF',
    secondaryMain: '#4D7CA4',
    sectionDesktop: {
      borderBottom: '#5FA7E3'
    },
    sectionHeader: {
      border: '#ADADAD',
      primary: '#808080',
      secondary: '#909090'
    },
    sectionLineHeader: 'gray',
    table: {
      alert: 'MistyRose'
    },
    tableCell: {
      head: {
        color: '#507FA5',
        borderBottomColor: '#507FA5'
      }
    },
    tabNavigation: {
      tabLink: {
        color: '#000'
      },
      tabLinkActive: {
        color: '#013862'
      }
    }
  },
  fonts: {
    default: 'Roboto'
  },
  fontSizes: {
    accordionSummary: {
      root: '56px'
    },
    logInTitle: '1rem',
    logOutTitle: '1.2rem',
    section: {
      sectionPrimaryText: '1rem',
      sectionSecondaryText: '0.9rem'
    },
    sectionLineHeader: '0.9rem',
    unionName: {
      primary: {
        fontSize: '1.4rem'
      },
      secondary: {
        fontSize: '1rem'
      }
    }
  },
  fontWeights: {
    buttonFont: 'normal'
  }
}

export default variables
